import styled from 'foundations-theming/utils';
const SystemMessageCenter = styled.div.attrs(() => ({
  'data-test-id': 'system-message-center'
})).withConfig({
  displayName: "SystemMessageCenter",
  componentId: "ds65vr-0"
})(["display:flex;align-items:center;justify-content:center;inline-size:", ";block-size:", ";border-radius:50%;z-index:1;color:", ";position:relative;"], ({
  theme
}) => theme.space[700], ({
  theme
}) => theme.space[800], ({
  theme
}) => theme.color['icon-core-subtle']);
SystemMessageCenter.displayName = 'SystemMessageCenter';
export default SystemMessageCenter;